export default __webpack_public_path__ + "static/media/landingBackground1.ba5dc7bf.png";